import { Box } from '@chakra-ui/react'

import { Dial, ErrorMessage, GaugeReading, Labels, Needle } from './dial-parts'

export interface DialChartProps {
  value: number | null | undefined
} // Calculate the semi-circle for the clip path
const precision = 64
const radius = 50
const semiCircleClipPath = [...Array(precision)].map((_, i) => {
  const a = (-i / (precision - 1)) * Math.PI * 2
  const x = (Math.cos(a) * radius) / 2 + 50 // need to fiddle with these #s to make the shape fit the aspect ratio of 2:1
  const y = Math.sin(a) * radius + 50 + 50
  return `${x}% ${y}%`
})

export const DialChart = ({ value, ...props }: DialChartProps) => {
  const hasValue = typeof value === 'number'
  const percent = value ?? 0

  return (
    <Box paddingX="20px" paddingTop="10px" paddingBottom="25px" {...props}>
      <Box width="330px" height="165px" position="relative">
        <Dial semiCircleClipPath={semiCircleClipPath} hasValue={hasValue} />
        <Labels transform="translateX(-50%) rotate(-90deg)">0%</Labels>
        <Labels transform="translateX(-50%) rotate(-54deg)">20%</Labels>
        <Labels transform="translateX(-50%) rotate(-18deg)">40%</Labels>
        <Labels transform="translateX(-50%) rotate(18deg)">60%</Labels>
        <Labels transform="translateX(-50%) rotate(54deg)">80%</Labels>
        <Labels transform="translateX(-50%) rotate(90deg)">100%</Labels>
        <Needle value={percent} />
        <GaugeReading value={percent} />
        {!hasValue && <ErrorMessage />}
      </Box>
    </Box>
  )
}
